const TicketStatusBadge = ({ stato }) => {
    const statusMap = {
      0: { text: "Aperto", color: "bg-danger" }, // Rosso
      1: { text: "In Corso", color: "bg-primary" }, // Giallo
      2: { text: "Risolto", color: "bg-success" }, // Verde
      3: { text: "Chiuso", color: "bg-secondary" }, // Grigio
    };
  
    const { text, color } = statusMap[stato] || statusMap[3]; // Default: Chiuso
  
    return <span className={`text-white badge ${color}`}>{text}</span>;
  };
  
  export default TicketStatusBadge;
  